import React from "react";
import { Col, Container, Form, Row } from "react-bootstrap";
import "../../styles/Contact/CompanyAddressDetails.scss";
import brandLogo from "../../assets/images/brandLogo.png";
import { FaMapMarkerAlt, FaPhoneAlt, FaMobileAlt } from "react-icons/fa";
import { RiMailOpenFill } from "react-icons/ri";
const CompanyAddressDetails = () => {
  return (
    <Container className="py-5">
      <Row>
        <Col md={6} className="image-and-address-container">
          <img src={brandLogo} alt="logo" />
          <div className="address-details">
            <div className="details-items">
              <span className="address-details-icon">
                <FaMapMarkerAlt />
              </span>
              Level-2, House, 363 Lane-5 Eastern Rd, Dhaka 1206, Bangladesh
            </div>
            <div className="details-items">
              <span className="address-details-icon">
                <FaPhoneAlt />
              </span>
              +88 02 222271328
            </div>
            <div className="details-items">
              <span className="address-details-icon">
                <FaMobileAlt />
              </span>
              +8801971604650
            </div>
            <div className="details-items">
              <span className="address-details-icon">
                <RiMailOpenFill />
              </span>
              info@mezroltd.com
            </div>
          </div>
        </Col>
        <Col md={6} className="company-address-details-form-bg">
          <h1 className="send-quote">Send your quote</h1>
          <Form>
            <Form.Group
              className="mb-3 custom-form-group"
              controlId="formBasicPassword"
            >
              <Form.Label className="label-title d-block m-auto w-75">
                Name
              </Form.Label>
              <Form.Control
                type="text"
                placeholder="Enter Your Name"
                className="place-holder-custom-design "
                style={{
                  backgroundColor: "transparent",
                  color: "#7D7A79",
                  borderTop: "0",
                  borderLeft: "0",
                  borderRight: "0",
                  borderBottom: "1.5px solid #7D7A79",
                  padding: "10px 0",
                  borderRadius: "0",
                  width: "75%",
                  display: "block",
                  margin: "auto",
                }}
              />
            </Form.Group>
            <Form.Group className="mb-3" controlId="formBasicEmail">
              <Form.Label className="label-title d-block m-auto w-75">
                Email
              </Form.Label>
              <Form.Control
                type="email"
                placeholder="Enter Your Email"
                className="place-holder-custom-design"
                style={{
                  backgroundColor: "transparent",
                  color: "#7D7A79",
                  borderTop: "0",
                  borderLeft: "0",
                  borderRight: "0",
                  borderBottom: "1.5px solid #7D7A79",
                  padding: "10px 0",
                  borderRadius: "0",
                  width: "75%",
                  display: "block",
                  margin: "auto",
                }}
              />
            </Form.Group>
            <Form.Group className="mb-3" controlId="formBasicEmail">
              <Form.Label className="label-title d-block m-auto w-75">
                Phone
              </Form.Label>
              <Form.Control
                type="number"
                placeholder="Enter your phone no."
                className="place-holder-custom-design"
                style={{
                  backgroundColor: "transparent",
                  color: "#7D7A79",
                  borderTop: "0",
                  borderLeft: "0",
                  borderRight: "0",
                  borderBottom: "1.5px solid #7D7A79",
                  padding: "10px 0",
                  borderRadius: "0",
                  width: "75%",
                  display: "block",
                  margin: "auto",
                }}
              />
            </Form.Group>
            <Form.Group className="mb-3" controlId="formBasicEmail">
              <Form.Label className="label-title d-block m-auto w-75">
                Comment
              </Form.Label>
              <Form.Control
                as="textarea"
                rows="1"
                cols="30"
                placeholder="Describe your project"
                className="place-holder-custom-design"
                style={{
                  backgroundColor: "transparent",
                  color: "#7D7A79",
                  borderTop: "0",
                  borderLeft: "0",
                  borderRight: "0",
                  borderBottom: "1.5px solid #7D7A79",
                  padding: "10px 0",
                  borderRadius: "0",
                  width: "75%",
                  display: "block",
                  margin: "auto",
                }}
              />
            </Form.Group>
            <button type="submit" className="form-submit">
              Submit
            </button>
          </Form>
        </Col>
      </Row>
    </Container>
  );
};

export default CompanyAddressDetails;
